import { TAG_NAME_CUT, TAG_NAME_RUN, TAG_TARGET_EVENT, TAG_TARGET_PLAYER } from '@videotools/js/api/entities/TagButton';

export default {
	namespaced: true,
	state:      () => ({
		active:  false,
		marking: {
			start: 0,
			end:   0,
		},
		markingTag: null,
	}),
	mutations: {
		setActive(state, active) {
			state.active = active;
		},
		setStart(state, val) {
			state.marking = { ...state.marking, start: val };
		},
		setEnd(state, val) {
			state.marking = { ...state.marking, end: val };
		},
		setMarkingTag(state, val) {
			state.markingTag = val;
		},
	},
	actions: {
		setActive({ commit }, active) {
			commit('setActive', active);
		},
		startMarking({ commit }, { position, tag }) {
			commit('setStart', position);
			commit('setActive', true);
			commit('setMarkingTag', tag);
		},
		endMarking({ commit }, position) {
			commit('setEnd', position);
			commit('setActive', false);
			commit('setMarkingTag', null);
		},
		setEnd({ commit }, val) {
			commit('setEnd', val);
		},
		cancel({ commit }) {
			commit('setActive', false);
			commit('setMarkingTag', null);
			commit('setStart', 0);
			commit('setEnd', 0);
		},
	},
	getters: {
		active:              state => state.active,
		start:               state => state.marking.start,
		end:                 state => state.marking.end,
		markingTag:          state => state.markingTag,
		isMarkingEvent:      state => state.active && state.markingTag?.name === TAG_NAME_CUT && state.markingTag?.target === TAG_TARGET_EVENT,
		isMarkingAthleteRun: state => state.active && state.markingTag?.name === TAG_NAME_RUN && state.markingTag?.target === TAG_TARGET_PLAYER,
		isMarkingAthlete:    state => state.active && state.markingTag?.name === TAG_NAME_CUT && state.markingTag?.target === TAG_TARGET_PLAYER,
	},
};
